import store from "../app/store";

function getUniqueArray(dataArray) {
  if (!Array.isArray(dataArray)) return [];

  const unique = [...new Set(dataArray)];
  return unique;
}

/**
 * Sends a URL to the backend to get crawled links that allready catch into and retrieves discovered links.
 *
 * - Makes a `POST` request to the `/crawl/getCrawlLinks` endpoint.
 * - Includes an authorization token from the Redux store.
 * - Returns structured response and meaningful error messages like RDS MySQL error handling.
 *
 * @async
 * @function GetCrawlLink
 * @param {string} urlToCrawl - The URL to crawl and extract links from.
 * @returns {Promise<{data: any[] | null, error: boolean, msg: string}>} A promise that resolves to an object:
 * - `data`: An array of discovered links (or `null` on failure).
 * - `error`: `true` if an error occurred, otherwise `false`.
 * - `msg`: A message describing success or the specific error.
 *
 * @example
 * const result = await GetCrawlLink("https://example.com");
 * if (!result.error) {
 *   console.log("Crawled Links:", result.data);
 * } else {
 *   console.error("Error:", result.msg);
 * }
 */

const GetCrawlLink = async (urlToCrawl) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/crawl/getCrawlLinks`;

  const token = store.getState().auth.token;

  if (!token) {
    return { data: null, error: "No token found" };
  }

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ url: urlToCrawl }),
  };

  try {
    const res = await fetch(url, options);

    if (!res.ok) {
      return { data: [], error: true };
    }

    const data = await res.json();
    const urls = getUniqueArray(data?.data);
    return { data: urls, error: false };
  } catch (err) {
    return { data: [], error: true };
  }
};

export default GetCrawlLink;
